module.exports = __webpack_public_path__ + "img/cms.426801c7.png";